/**
 * Bridge from wire DTOs to the domain engine, shared by server and web so both compute
 * exactly the same forecasts and statuses.
 */
import {
  projectView,
  type ProjectInput,
  type ProjectView,
  type StepInput,
  type WorkCalendar,
} from '@pace/domain';
import type { ProjectDTO, StepDTO } from './projects';

const bySeq = (a: StepDTO, b: StepDTO) => a.seq - b.seq;

export const stepInput = (s: StepDTO): StepInput => ({
  id: s.id,
  state: s.state,
  days: s.days,
  planned: s.planned,
  baseline: s.baseline,
  actual: s.actual,
});

/** Steps of one tool (or the milestones when toolId is null), in order. */
export function chainSteps(p: ProjectDTO, toolId: string | null): StepDTO[] {
  return p.steps.filter((s) => s.toolId === toolId).sort(bySeq);
}

export function projectInput(p: ProjectDTO): ProjectInput {
  return {
    id: p.id,
    phase: p.phase,
    startDate: p.startDate,
    tools: [...p.tools]
      .sort((a, b) => a.sort - b.sort)
      .map((t) => ({ id: t.id, steps: chainSteps(p, t.id).map(stepInput) })),
    milestones: chainSteps(p, null).map(stepInput),
  };
}

export const viewOf = (p: ProjectDTO, today: string, cal: WorkCalendar): ProjectView =>
  projectView(projectInput(p), today, cal);
